/**
 * Created by lobin on 2019/1/21.
 */
import { Base64 } from "js-base64";
// base64编码
export const base64 = str => Base64.encode(str);
// 正则
export const regular = {
  phone: /^(\+?0?86\-?)?1[3456789]\d{9}$/
};
